module.exports = __webpack_public_path__ + "img/180.5fc4b48a.jpg";